import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {
    doctor: [],
    area: [],
    weekDay: [],
  },
};

export const DoctorAvailabilitySlice = createSlice({
  name: "DoctorAvailabilityReducer",
  initialState,
  reducers: {
    setDoctorAvailabilityList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setDoctorComboList: (state, action) => {
      state.filters.doctor = action.payload;
    },
    setAreaComboList: (state, action) => {
      state.filters.area = action.payload;
    },
    setWeekDayList: (state, action) => {
      state.filters.weekDay = action.payload;
    },
  },
});

export const { setDoctorAvailabilityList, setDoctorComboList, setAreaComboList, setWeekDayList } =
  DoctorAvailabilitySlice.actions;

export default DoctorAvailabilitySlice.reducer;
